import * as React from "react";
import DialogContentText from "@mui/material/DialogContentText";
import { FormProvider } from "react-hook-form";

import arrow from "../../../../../../styles/svg/arrow.svg";
import "./ChangeBoardToDifferentWorkflow.scss";
import CustomMenuItem from "../../../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../../../components/Dialog/FormDialog";
import { RFHTextField, RHFSelect } from "../../../../../../components/RFH";
import { useChangeBoardWorkflowState } from "./hooks/useChangeBoardWorkflowState";

export default function ChangeBoardToDifferentWorkflow({
  open,
  close,
  card,
  currentBoardName,
  targetBoardName,
  workflowId,
  cardId,
  targetBoardId,
  currentBoardWorkflowId,
  currentWorkflowStepId,
  isTodo,
}) {
  const {
    currentWorkflowStepStatus,
    formMethods,
    handleMove,
    isMobile,
    isPending,
    isSubmitDisabled,
    shouldSelectTargetStep,
    workflowSteps,
  } = useChangeBoardWorkflowState({
    close,
    currentWorkflowStepId,
    card,
    cardId,
    currentBoardWorkflowId,
    isTodo,
    targetBoardId,
    workflowId,
  });

  return (
    <React.Fragment>
      <FormProvider {...formMethods}>
        <form onSubmit={handleMove}>
          <FormDialog
            open={open}
            handleClose={() => close(false)}
            title={"Move Task to Another Board"}
            buttonTxt={"Move"}
            width={494}
            fullWidth={true}
            disabled={isSubmitDisabled}
            handleSubmit={handleMove}
          >
            <div className="move-ticket-dialog-content">
              {shouldSelectTargetStep ? (
                <DialogContentText className="move-ticket-dialog-contentText">
                  Origin and Destination boards use different workflow steps,
                  select the step you want to put this task in when moving it to
                  the destination board.
                </DialogContentText>
              ) : (
                <DialogContentText className="move-ticket-dialog-contentText">
                  Origin and Destination boards use the same workflow steps, so
                  the task will automatically move to its corresponding step in
                  the destination board.
                </DialogContentText>
              )}
              {shouldSelectTargetStep && (
                <div className="move-ticket-form-dialogContent">
                  <div
                    className={
                      isMobile
                        ? "mobile-ticket-reasign-step-container"
                        : "ticket-reasign-step-container"
                    }
                  >
                    <div
                      className={
                        isMobile
                          ? "mobile-current-target-board-name"
                          : "current-target-board-name"
                      }
                    >
                      <p> {currentBoardName} </p>
                      <div className="initial-step">
                        <RFHTextField
                          name={"test"}
                          className="mui-status-field change-board-workflow"
                          disabled
                          value={currentWorkflowStepStatus}
                          defaultPadding={false}
                        />
                      </div>
                    </div>
                    <img src={arrow} alt="" />
                    <div
                      className={
                        isMobile
                          ? "mobile-current-target-board-name"
                          : "current-target-board-name"
                      }
                    >
                      <p>{targetBoardName}</p>
                      <div className="initial-step">
                        <RHFSelect
                          name="targetStep"
                          sx={{
                            width: isMobile ? "100%" : "180px",
                          }}
                          className="mui-status-field"
                          required
                        >
                          {workflowSteps.map((option) => (
                            <CustomMenuItem
                              key={option?.workflow_step_id}
                              id={option?.workflow_step_id}
                              value={option.workflow_step_id}
                              className="uppercase"
                            >
                              {option.status}
                            </CustomMenuItem>
                          ))}
                        </RHFSelect>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </FormDialog>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}
